import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router' 
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Vant from 'vant'
import 'vant/lib/index.css'
import { i18n, langLoaded, loadLanguage, init as i18nInit } from './i18n/index';
// Import locale
import { Locale } from 'vant'
import ptBR from 'vant/es/locale/lang/pt-BR'  // Portuguese (Brazil)
import './registerServiceWorker'
import { initSSE } from './utils/sse';
// Apply locale globally
Locale.use('pt-BR', ptBR)

const app = createApp(App)
const pinia = createPinia();

const token = localStorage.getItem('token')
if (token) {
  initSSE(process.env.VUE_APP_BASE_API + '/app/resource/sse')
}

// Initialize i18n
i18nInit();

pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(Vant);
app.use(router);
app.use(i18n);
app.mount('#app')
